import Card from '../../../components/Card';
import useChartState from '../../../context/chart/useChartState';
import { formatAmountWithSuffix, formatPercentages } from '../../../helpers';
import useDailyVolume from '../../../hooks/web3/trade/useDailyVolume';
import useFundingFeesRate from '../../../hooks/web3/trade/useFundingFeesRate';
import usePositionStats from '../../../hooks/web3/trade/usePositionStats';
import Detail from './Detail';
import MarketPrice from './MarketPrice';
import { parseEther } from 'ethers/lib/utils';

const ExchangeHeader = () => {
    const { selectedTradePair } = useChartState();

    const { positionStats } = usePositionStats();
    const { fundingFeesRate } = useFundingFeesRate();
    const { dailyVolume } = useDailyVolume();

    return (
        <div className='exchange-header'>
            <Card>
                <Card>
                    <div className='exchange-details'>
                        <MarketPrice pool={selectedTradePair} />
                        <div className='divider' />
                        <div className='market-stats'>
                            <Detail
                                title='Longs'
                                value={`${
                                    positionStats && selectedTradePair
                                        ? formatAmountWithSuffix(
                                              positionStats[selectedTradePair.address]
                                                  .totalLongVolume || '0',
                                              {
                                                  maxDecimals: 0,
                                                  minValue: 1000,
                                              }
                                          )
                                        : '-'
                                } / ${
                                    positionStats && selectedTradePair
                                        ? formatAmountWithSuffix(
                                              positionStats[selectedTradePair.address]
                                                  .totalSizeLimit || '0',
                                              { maxDecimals: 0, minValue: 1000 }
                                          )
                                        : '-'
                                }`}
                            />
                            <Detail
                                title='Shorts'
                                value={`${
                                    positionStats && selectedTradePair
                                        ? formatAmountWithSuffix(
                                              positionStats[selectedTradePair.address]
                                                  .totalShortVolume || '0',
                                              {
                                                  maxDecimals: 0,
                                                  minValue: 1000,
                                              }
                                          )
                                        : '-'
                                } / ${
                                    positionStats && selectedTradePair
                                        ? formatAmountWithSuffix(
                                              positionStats[selectedTradePair.address]
                                                  .totalSizeLimit || '0',
                                              { maxDecimals: 0, minValue: 1000 }
                                          )
                                        : '-'
                                }`}
                            />
                            <Detail
                                title='Funding 1h (L/S)'
                                value={
                                    <>
                                        <span
                                            className={
                                                fundingFeesRate
                                                    ? parseEther(
                                                          fundingFeesRate.long
                                                      ).gte(0)
                                                        ? 'decreased'
                                                        : 'increased'
                                                    : ''
                                            }
                                        >
                                            {fundingFeesRate
                                                ? `${formatPercentages(
                                                      Math.abs(
                                                          +fundingFeesRate.long || 0
                                                      ),
                                                      4
                                                  )}%`
                                                : '-'}
                                        </span>
                                        {` / `}
                                        <span
                                            className={
                                                fundingFeesRate
                                                    ? parseEther(
                                                          fundingFeesRate.short
                                                      ).gte(0)
                                                        ? 'decreased'
                                                        : 'increased'
                                                    : ''
                                            }
                                        >
                                            {fundingFeesRate
                                                ? `${formatPercentages(
                                                      Math.abs(
                                                          +fundingFeesRate.short || 0
                                                      ),
                                                      4
                                                  )}%`
                                                : '-'}
                                        </span>
                                    </>
                                }
                            />{' '}
                            <Detail
                                title='24h Volume'
                                value={
                                    dailyVolume &&
                                    selectedTradePair &&
                                    dailyVolume[selectedTradePair.address]
                                        ? `${formatAmountWithSuffix(
                                              dailyVolume[selectedTradePair.address],
                                              {
                                                  minDecimals: 2,
                                                  minValue: 1000,
                                              }
                                          )}`
                                        : ' -'
                                }
                            />
                        </div>
                    </div>
                </Card>
            </Card>
        </div>
    );
};

export default ExchangeHeader;
